import { render, staticRenderFns } from "./pill-cta.vue?vue&type=template&id=3473db2e&scoped=true&lang=pug&"
import script from "./pill-cta.vue?vue&type=script&lang=js&"
export * from "./pill-cta.vue?vue&type=script&lang=js&"
import style0 from "./pill-cta.vue?vue&type=style&index=0&id=3473db2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473db2e",
  null
  
)

export default component.exports